import { atom } from 'jotai';
import { NetworkStatus } from '@antimatterhq/ui/types/NetworkStatus';

export const networkStatusAtom = atom<NetworkStatus>('online');
